export const API_URL = window.location.hostname === 'localhost'
    ? 'http://localhost:5000/api'
    : 'https://yoga-br-delta.vercel.app/api';

export const apiCall = async (endpoint, method = 'GET', body = null, isFileUpload = false) => {
    const headers = {};

    if (!isFileUpload) {
        headers['Content-Type'] = 'application/json';
    }

    const token = localStorage.getItem('token');
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const config = {
        method,
        headers,
    };

    if (body) {
        config.body = isFileUpload ? body : JSON.stringify(body);
    }

    try {
        const response = await fetch(`${API_URL}${endpoint}`, config);

        // Check if response is JSON
        const contentType = response.headers.get('content-type');

        if (!contentType || !contentType.includes('application/json')) {
            // If not JSON, try to get text for better error message
            const text = await response.text();
            console.error('Non-JSON response received:', {
                url: `${API_URL}${endpoint}`,
                status: response.status,
                contentType,
                responsePreview: text.substring(0, 200)
            });
            throw new Error(`Server returned non-JSON response (${response.status}). This usually means the API endpoint is not found or there's a server error.`);
        }

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || `Request failed with status ${response.status}`);
        }

        return data;
    } catch (error) {
        console.error('API Call Error:', {
            endpoint,
            method,
            error: error.message
        });
        throw error;
    }
};
